require('./mortgageRequestErrorCustom.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames')

// @ utilities
const { formatText } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

const MortgageRequestErrorCustom = props => {
    const {
        columns,
        columnsOffset,
        errorTitle,
        goBackButtonLabel,
        goBackButtonLink,
        onGoBackButtonClick,
        children
    } = props;

    const columnsClass = columns && `col-xs-${columns}`;
    const columnsOffsetClass = columnsOffset && `col-xs-offset-${columnsOffset}`;
    const errorMainClass = classnames(columnsClass, columnsOffsetClass);

    let goBackButton;
    if (onGoBackButtonClick) {
        goBackButton = (
            <OKButton modifier="link-complementary" onClick={onGoBackButtonClick}>
                {goBackButtonLabel}
            </OKButton>
        );
    } else {
        goBackButton = (
            <OKLink modifier="emphasize" to={goBackButtonLink} >
                {goBackButtonLabel}
            </OKLink>
        );
    }

    return (
        <div className="row mortgage-request-error-custom">
            <div className={errorMainClass}>
                <ContentBox>
                    <div className="mortgage-request-error-custom__highlight">
                        <i className="mortgage-request-error-custom__error-icon"></i>
                        <div className="mortgage-request-error-custom__title">
                            <OKBoxTitle value={errorTitle} />
                        </div>
                    </div>

                    <div className="mortgage-request-error-custom__content">
                        <div className="mortgage-request-error-custom__text">
                            {children}
                        </div>
                        <div className="mortgage-request-error-custom__footer">
                            <div className="mortgage-request-error-custom__separator" />
                            <div className="mortgage-request-error-custom__link">
                                {goBackButton}
                            </div>
                        </div>
                    </div>
                </ContentBox>
            </div>
        </div>
    );
};

MortgageRequestErrorCustom.propTypes = {
    columns: PropTypes.number,
    columnsOffset: PropTypes.number,
    errorTitle: PropTypes.string,
    goBackButtonLabel: PropTypes.string,
    goBackButtonLink: PropTypes.string,
    onGoBackButtonClick: PropTypes.func,
    children: PropTypes.object
}

MortgageRequestErrorCustom.defaultProps = {
    columns: 12,
    columnsOffset: 0,
    errorTitle: formatText('mortgageRequestError-titleHeader'),
    goBackButtonLabel: formatText('mortgageRequestError-returnLoans'),
    goBackButtonLink: '/myprofile/mortgage/panel'
}

module.exports = MortgageRequestErrorCustom;